module.exports = __webpack_public_path__ + "static/dietopro-eni.e2f7a4f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cases/detail/dietopro-eni.jpg
// module id = 590
// module chunks = 101035529556142